<div class="skipto-links">
  <a (click)="focusOnArea($event, focusArea)" *ngFor="let focusArea of focusAreas" href="#">{{ focusArea.label }}</a>
</div>
<app-header [isEmbed]="isEmbed"></app-header>
<content class="main-content">
  <router-outlet></router-outlet>
</content>
<app-footer [isEmbed]="isEmbed" [justOverlay]="auth.loggedIn && !auth.isClient"></app-footer>